export var PROFIT_LOSS_EVENT_NAME = 'my_transactions_interactions';